import { ReactNode } from 'react';
import NotFound from './NotFound';
import { useTenant } from './useTenant';

// Unknown subdomains otherwise render each page's own empty state and look like
// a real, empty org. Only a 404 gates, so a flaky lookup can't 404 real tenants.
export default function TenantGate({ children }: { children: ReactNode }) {
  if (useTenant().isNotFound) {
    // No home button: '/' on a subdomain with no tenant just re-renders this page.
    return (
      <NotFound
        reason="unknown_tenant"
        message="This Page Does Not Exist"
        description={
          <>
            If you are facing a problem, reach out to our support team at{' '}
            <a
              href="mailto:support@recruit41.com"
              className="font-semibold text-primary-500 hover:text-primary-700 underline"
            >
              support@recruit41.com
            </a>
          </>
        }
        showHomeButton={false}
      />
    );
  }

  return <>{children}</>;
}
